module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4IJx5"))).then(() => module.bundle.root('3I97s'));